// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page{
  padding:15px;
  background:#bfcbdd;
}

/* HEADER */
.titleBar{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:10px;
}

/* TABLE WRAPPER */
.table-wrapper{
  height:70vh;
  overflow:auto;
  border:1px solid #bbb;
  background:#fff;
}

/* MAIN TABLE */
.scada-table{
  border-collapse: collapse;
  min-width: 1800px;   /* IMPORTANT: prevents column breaking */
  width: max-content;
  font-family: Arial, sans-serif;
}

/* COMMON CELL STYLE */
.scada-table th,
.scada-table td{
  border:1px solid #444;
  padding:8px;
  text-align:center;
  white-space:nowrap;
  font-size:13px;
  min-width:90px;   /* KEY FIX for alignment */
}

/* =========================
   STICKY HEADER (3 LEVEL)
========================= */

/* LEVEL 1 */
.scada-table thead tr:nth-child(1) th{
  position: sticky;
  top: 0;
  z-index: 6;
}

/* LEVEL 2 */
.scada-table thead tr:nth-child(2) th{
  position: sticky;
  top: 40px;
  z-index: 5;
}

/* LEVEL 3 */
.scada-table thead tr:nth-child(3) th{
  position: sticky;
  top: 80px;
  z-index: 4;
}

/* =========================
   STICKY FIRST COLUMN
========================= */
.scada-table th:first-child,
.scada-table td:first-child{
  position: sticky;
  left: 0;
  z-index: 10;
  background:#fff;
}

.scada-table thead th:first-child{
  z-index: 20; /* top priority */
}

/* =========================
   HEADER COLORS
========================= */

.date-col{
  background:#084971;
  color:#0f0404;
  font-weight:600;
}

.head-green{
  background:#4CAF50;
  color:#fff;
  font-size:16px;
  font-weight:600;
}

.head-orange{
  background:#f4b183;
  font-weight:600;
}

.head-blue{
  background:#9dc3e6;
  font-weight:600;
}

/* SUB HEADER COLORS */
.scada-table thead tr:nth-child(2) th{
  background:#d9ead3;
}

.scada-table thead tr:nth-child(3) th{
  background:#fff2cc;
}

/* =========================
   ROW HOVER EFFECT
========================= */
.scada-table tbody tr:hover{
  background:#eef7ff;
  transition:0.2s;
}

/* =========================
   LOADING STYLE
========================= */
.loading{
  padding:50px;
  text-align:center;
  font-size:20px;
}

/* =========================
   SCROLLBAR (OPTIONAL NICE UI)
========================= */
.table-wrapper::-webkit-scrollbar{
  height:10px;
  width:10px;
}

.table-wrapper::-webkit-scrollbar-thumb{
  background:#888;
  border-radius:5px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover{
  background:#555;
}`, "",{"version":3,"sources":["webpack://./src/pages/GisTools/SCADAWTPDetails.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,iBAAiB,IAAI,wCAAwC;EAC7D,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;;EAEE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc,IAAI,0BAA0B;AAC9C;;AAEA;;2BAE2B;;AAE3B,YAAY;AACZ;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;2BAE2B;AAC3B;;EAEE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW,EAAE,iBAAiB;AAChC;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;2BAE2B;AAC3B;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".page{\n  padding:15px;\n  background:#bfcbdd;\n}\n\n/* HEADER */\n.titleBar{\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  margin-bottom:10px;\n}\n\n/* TABLE WRAPPER */\n.table-wrapper{\n  height:70vh;\n  overflow:auto;\n  border:1px solid #bbb;\n  background:#fff;\n}\n\n/* MAIN TABLE */\n.scada-table{\n  border-collapse: collapse;\n  min-width: 1800px;   /* IMPORTANT: prevents column breaking */\n  width: max-content;\n  font-family: Arial, sans-serif;\n}\n\n/* COMMON CELL STYLE */\n.scada-table th,\n.scada-table td{\n  border:1px solid #444;\n  padding:8px;\n  text-align:center;\n  white-space:nowrap;\n  font-size:13px;\n  min-width:90px;   /* KEY FIX for alignment */\n}\n\n/* =========================\n   STICKY HEADER (3 LEVEL)\n========================= */\n\n/* LEVEL 1 */\n.scada-table thead tr:nth-child(1) th{\n  position: sticky;\n  top: 0;\n  z-index: 6;\n}\n\n/* LEVEL 2 */\n.scada-table thead tr:nth-child(2) th{\n  position: sticky;\n  top: 40px;\n  z-index: 5;\n}\n\n/* LEVEL 3 */\n.scada-table thead tr:nth-child(3) th{\n  position: sticky;\n  top: 80px;\n  z-index: 4;\n}\n\n/* =========================\n   STICKY FIRST COLUMN\n========================= */\n.scada-table th:first-child,\n.scada-table td:first-child{\n  position: sticky;\n  left: 0;\n  z-index: 10;\n  background:#fff;\n}\n\n.scada-table thead th:first-child{\n  z-index: 20; /* top priority */\n}\n\n/* =========================\n   HEADER COLORS\n========================= */\n\n.date-col{\n  background:#084971;\n  color:#0f0404;\n  font-weight:600;\n}\n\n.head-green{\n  background:#4CAF50;\n  color:#fff;\n  font-size:16px;\n  font-weight:600;\n}\n\n.head-orange{\n  background:#f4b183;\n  font-weight:600;\n}\n\n.head-blue{\n  background:#9dc3e6;\n  font-weight:600;\n}\n\n/* SUB HEADER COLORS */\n.scada-table thead tr:nth-child(2) th{\n  background:#d9ead3;\n}\n\n.scada-table thead tr:nth-child(3) th{\n  background:#fff2cc;\n}\n\n/* =========================\n   ROW HOVER EFFECT\n========================= */\n.scada-table tbody tr:hover{\n  background:#eef7ff;\n  transition:0.2s;\n}\n\n/* =========================\n   LOADING STYLE\n========================= */\n.loading{\n  padding:50px;\n  text-align:center;\n  font-size:20px;\n}\n\n/* =========================\n   SCROLLBAR (OPTIONAL NICE UI)\n========================= */\n.table-wrapper::-webkit-scrollbar{\n  height:10px;\n  width:10px;\n}\n\n.table-wrapper::-webkit-scrollbar-thumb{\n  background:#888;\n  border-radius:5px;\n}\n\n.table-wrapper::-webkit-scrollbar-thumb:hover{\n  background:#555;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
